import { render } from "./UiTextInput.vue?vue&type=template&id=5352b608"
import script from "./UiTextInput.vue?vue&type=script&lang=js"
export * from "./UiTextInput.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__